import { RotateCw } from 'lucide-react';
import { Feedback } from './feedback.js';
import { Button } from './button.js';

interface QueryErrorProps {
  /** Plain-words description of what failed, e.g. "Couldn't load customers". */
  title: string;
  /** The query/mutation error — its message renders as the detail line. */
  error?: unknown;
  /** Usually `() => void query.refetch()`. */
  onRetry: () => void;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Retryable error card — Feedback (role="alert") plus a Retry button, per
 * the "tap to retry" contract in lib/query.ts. Use for failed loads instead
 * of a dead error box.
 */
export function QueryError({ title, error, onRetry, size = 'lg', className }: QueryErrorProps) {
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : null;
  return (
    <Feedback variant="error" size={size} className={className}>
      <div className="font-semibold">{title}</div>
      {message && <div className="text-xs mt-1 opacity-80">{message}</div>}
      <Button variant="secondary" size="sm" onClick={onRetry} className="mt-2">
        <RotateCw className="h-3.5 w-3.5" aria-hidden />
        Retry
      </Button>
    </Feedback>
  );
}
